import Api from '../../common/api';

const api = Api.getApi();

export async function requestGetTag({ id }) {
  const response = await api.request('get', `/tags/${id}`);
  const { data, metadata } = response;
  return { data, metadata };
}

export async function requestGetTags(query) {
  const response = await api.request('get', '/tags', {
    params: { include_tag_values: true, ...query },
  });
  const { data, metadata } = response;
  return { data, metadata };
}

export async function requestPostTag(data) {
  return api.request('post', '/tags', data);
}

export async function requestPutTag(id, data) {
  return api.request('put', `/tags/${id}`, data);
}

export async function requestPostTagValue(id, body) {
  return api.request('post', `/tags/${id}/values`, body);
}

export async function requestPutTagValue(id, tagValueId, body) {
  return api.request('put', `/tags/${id}/values/${tagValueId}`, body);
}

export async function requestDeleteTagValue(id, tagValueId) {
  return api.request('delete', `/tags/${id}/values/${tagValueId}`);
}

export async function requestDeleteTag(id) {
  return api.request('delete', `/tags/${id}`);
}

